var hasHiddenParent = function hasHiddenParent(element) {
  if (element) {
    var style = getComputedStyle(element);

    if ( // must have a style that visually hides it
    style.display === "none" || style.visibility === "hidden" || style.opacity === "0") {
      return true;
    } else if (element.parentElement) {
      return hasHiddenParent(element.parentElement);
    }
  }

  return false;
};

export { hasHiddenParent };